import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ReportParametersState {
	byReportId: Record<string, Record<string, unknown>>;
}

const initialState: ReportParametersState = {
	byReportId: {}
};

export const reportParametersSlice = createSlice({
	initialState,
	name: "reportParameters",
	reducers: {
		hydrateReportParameterValues: (
			state,
			action: PayloadAction<{ reportId: string; values: Record<string, unknown> }>
		) => {
			const { reportId, values } = action.payload;
			const current = state.byReportId[reportId] ?? {};
			for (const [key, value] of Object.entries(values)) {
				if (current[key] === undefined) {
					current[key] = value;
				}
			}
			state.byReportId[reportId] = current;
		},
		setReportParameterValues: (state, action: PayloadAction<{ reportId: string; values: Record<string, unknown> }>) => {
			state.byReportId[action.payload.reportId] = action.payload.values;
		}
	}
});

export const { hydrateReportParameterValues, setReportParameterValues } = reportParametersSlice.actions;

export default reportParametersSlice.reducer;
